<div #gridElement [ngClass]="{'icon-boarder' : !active, 'active-item': active}">
  <img src="{{getLogoUrl()}}" class="icon">
</div>
